import EventEmitter from "events";
import { ILog, ILogEntries, ILogEntry, LogEntryType } from "./types";


export class InMemoryLog extends EventEmitter implements ILog, ILogEntries {

    private readonly _maxItems: number;
    private _entries: ILogEntry[] = [];

    constructor (maxItems: number) {
        super();

        this._maxItems = Math.max(1, maxItems);
    }

    public get entries(): ILogEntry[] { return this._entries; };

    public error(message: string, data: any | null) {
        this._entries.push({ at: new Date(), type: LogEntryType.Error, message, data });
        this._entries = this._entries.slice(0, this._maxItems);
        this.emit('entriesChanged');
    };

    public warning(message: string, data: any | null) {
        this._entries.push({ at: new Date(), type: LogEntryType.Warning, message, data });
        this._entries = this._entries.slice(0, this._maxItems);
        this.emit('entriesChanged');
    };

    public info(message: string, data: any | null) {
        this._entries.push({ at: new Date(), type: LogEntryType.Info, message, data });
        this._entries = this._entries.slice(0, this._maxItems);
        this.emit('entriesChanged');
    };

};